webpackJsonp([175342564634183],{

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Connect = __webpack_require__(29);
	
	var _Connect2 = _interopRequireDefault(_Connect);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Connect2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'findAll'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This blueprint mirrors the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'find'
	      ),
	      ' blueprint, but adds a helper to automatically include data that matches the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'where'
	      ),
	      ' object.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This is useful if you want to display a list of data (such as tweets created by a user) and then automatically have new tweets they create show up at the top of that list.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Example usage is below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import { connect } from \'lore-hook-connect\';\n\n      connect((getState, props) => {\n        return {\n          tweets: getState(\'tweet.findAll\', {\n            where: {\n              user: 1\n            }\n          })\n        }\n      })\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When invoked, this blueprint will create a API call, and then automatically merge data from the Redux Store into the object it returns, as long as that data matches all fields provided in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'where'
	      ),
	      ' attribute.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To illustrate, imagine the query above returned 3 tweets (meaning the API has 3 tweets created by the user with the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      ' of 1, who we will pretend is the current user):'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'First tweet'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Second tweet'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Third tweet'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Now imagine the current user composes another tweet, and sends it. Because this tweet is now in our Redux Store, and the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'user'
	      ),
	      ' attribute is equal to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '1'
	      ),
	      ', it will automatically be included in the response from this blueprint, and the data returned from the blueprint will now look like this:'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'NEW tweet'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'First tweet'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Second tweet'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Third tweet'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In other words, this blueprint returns ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'the original cached response from the API'
	      ),
	      ' ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'plus'
	      ),
	      ' any additional data that lives in the Redux Store matching that criteria.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Blueprint'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import find from \'./find\';\n\n      export default _.defaultsDeep({\n\n        defaults: {\n          include: {\n            where: function(model, params) {\n              if (_.keys(params.where).length > 0) {\n                return _.isMatch(model.data, params.where);\n              }\n\n              return true;\n            }\n          }\n        }\n\n      }, find);\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-connect-find-all-js-da0334e7d9e661ac11cc.js